module.exports = __webpack_public_path__ + "static/business-baae3ed433a9b657ea70c5cc11cfa7e3.jpg";